/* eslint-disable @typescript-eslint/no-explicit-any */
interface Props {
  active?: boolean;
  payload?: { name: string; value: number; color: string }[];
  label?: string;
  formatValue?: (value: number, name: string) => string;
}

export function ChartTooltip({ active, payload, label, formatValue }: Props) {
  if (!active || !payload?.length) return null;
  const format = formatValue ?? ((value: number) => value.toLocaleString('ru-RU'));
  return (
    <div className='bg-card rounded-[10px] px-2.5 py-1.5 pointer-events-none'>
      {label && <div className='text-[11px] text-muted-foreground mb-0.5'>{label}</div>}
      {payload.map((entry: any) => (
        <div key={entry.name} className='text-[13px] font-semibold' style={{ color: entry.color }}>
          {format(entry.value, entry.name)}
        </div>
      ))}
    </div>
  );
}
